// fetch() rejects with a TypeError when the request never gets a response
// (offline, connection dropped, blocked by an extension). Each browser words
// it differently; matching the message keeps code bugs that also throw
// TypeErrors from being reported to the user as connection problems.
const NETWORK_ERROR_MESSAGES = [
  'Failed to fetch', // Chrome, Edge
  'Load failed', // Safari
  'NetworkError when attempting to fetch resource.' // Firefox
];

export function isNetworkError(err: unknown): boolean {
  return (
    err instanceof TypeError && NETWORK_ERROR_MESSAGES.includes(err.message)
  );
}
